import React, { Fragment } from "react";
import PropTypes from "prop-types";
import qs from "web/core/utils/queryString";
import FilterItem from "theme/components/molecules/FilterItem";
import OptionPicker from "theme/components/molecules/OptionPicker";
import EnhanceLayeredNavigation from "./EnhanceLayeredNavigation";
import Button from "theme/components/atoms/Button";
import LabelledIcon from "theme/components/molecules/LabelledIcon";
import IsDesktop from "theme/utils/isDesktop";
import { defineMessages, useIntl } from "react-intl";
const messages = defineMessages({
  categoryLabel: {
    id: "modules.Layer.LayeredNavigation.categoryLabel",
    defaultMessage: "Category",
  },
});
const LayeredNavigation = (props) => {
  const intl = useIntl();

  const query = qs.parse(props.location.search);
  if (!props.layer || props.layer.dynamicFacets.length === 0) {
    return null;
  } else {
    return (
      <div className="layered-navigation">
        {props.layer.dynamicFacets.map((attribute) => {
          const currentValues = query[
            attribute.code === "gender" ? "genre" : attribute.code
          ]
            ? [].concat(
                query[attribute.code === "gender" ? "genre" : attribute.code]
              )
            : [];
          const options = attribute.buckets.map((doc) => ({
            value: doc.value,
            label: doc.label,
          }));

          if (
            attribute.buckets.length === 1 &&
            (currentValues.indexOf(attribute.buckets[0].value) !== -1 ||
              (attribute.code === "gender" && currentValues.length > 0))
          ) {
            return (
              <FilterItem
                key={attribute.code}
                label={attribute.label}
                initiallyOpen={true}
              >
                {(opened) =>
                  opened && (
                    <Button
                      appearance="ghost"
                      onClick={() => {
                        if (attribute.code === "gender") {
                          props.onChange({
                            [attribute.code]: [],
                          });
                          props.resetGenderFilter();
                        } else {
                          props.onChange({
                            [attribute.code]: query[attribute.code].filter(
                              (currentValue) =>
                                currentValue !== attribute.buckets[0].value
                            ),
                          });
                        }
                      }}
                    >
                      <LabelledIcon icon="cross" size="tiny" inverted>
                        {attribute.buckets[0].label}
                      </LabelledIcon>
                    </Button>
                  )
                }
              </FilterItem>
            );
          }

          return (
            Boolean(options.length) && (
              <IsDesktop key={attribute.code}>
                {(isDesktop) => (
                  <FilterItem
                    label={
                      attribute.label === "Category"
                        ? intl.formatMessage(messages.categoryLabel)
                        : attribute.label
                    }
                    initiallyOpen={isDesktop ? true : false}
                  >
                    {(opened) =>
                      opened ? (
                        <OptionPicker
                          name={attribute.code}
                          options={options}
                          onChange={props.onChange}
                          currentValues={currentValues}
                          limitBy={5}
                        />
                      ) : (
                        <Fragment />
                      )
                    }
                  </FilterItem>
                )}
              </IsDesktop>
            )
          );
        })}
      </div>
    );
  }
};

const SmartLayeredNavigation = EnhanceLayeredNavigation()(LayeredNavigation);

LayeredNavigation.propTypes = {
  layer: PropTypes.object.isRequired, // from LayeredNavigationFragment
  location: PropTypes.object.isRequired,
};

export default SmartLayeredNavigation;
